<p-card header="Repair Line Inventory">
    <div [formGroup]="repairLineInventoryForm">
        <p-table [value]="repairLineInventoryItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>Product<span class="required">*</span></th>
                    <th>Pieces<span class="required">*</span></th>
                    <th>Delete</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
                <tr [formGroup]="rowData">
                    <td>
                        <p-dropdown
                          [options]="products"
                          appendTo="body"
                          formControlName="productId"
                          name="product"
                          [required]="true"
                          [filter]="true"
                          [editable]="false"
                          [resetFilterOnHide]="true">
                        </p-dropdown>
                    </td>
                    <td>
                        <input pInputText type="number"
                          formControlName="pieces1"
                          style="width:100%"
                          name="pieces"
                          required
                          lib-numeric>
                    </td>
                    <td>
                        <confirmation-button
                          [iconsOnly]="true"
                          actionIcon="pi pi-times"
                          actionText="Delete"
                          confirmIcon="pi pi-times"
                          confirmText="Delete"
                          cancelIcon="pi pi-minus-circle"
                          cancelText="Cancel"
                          [disabled]="rowData.disabled"
                          (actionConfirmed)="deleteRepairLine(rowData)">
                        </confirmation-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                  <td [attr.colspan]="3" class="centered">
                    No data available
                  </td>
                </tr>
              </ng-template>
            <ng-template pTemplate="footer" let-rowData>
                <tr [formGroup]="repairLineInventoryForm">
                    <td>
                        <p-dropdown [options]="products" [required] placeholder="-- Select Product --" inputId="productID"
                            class="form-control" name="product" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="product" appendTo="body">
                        </p-dropdown>
                        <error-block [field]="repairLineInventoryForm.controls.product" [messages]="{
                            required: 'Product is required.'
                          }">
                          </error-block>
                    </td>
                    <td>
                        <input type="number" lib-numeric pInputText id="pieces" required name="pieces" class="form-control" formControlName="pieces"/>
                        <error-block [field]="repairLineInventoryForm.controls.pieces" [messages]="{
                            required: 'Pieces is required.'
                          }">
                          </error-block>
                    </td>
                    <td>
                        <button type="button" pButton
                          icon="pi pi-plus"
                          iconPos="left"
                          (click)="saveRLI();"
                          label="Add"
                          [disabled]="repairLineInventoryForm.disabled"
                          [ngClass]="{ 'p-state-disabled': !repairLineInventoryForm.valid }"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>
